import BaseSelectionType from "./BaseSelectionType";
import SelectedData from "./model/SelectedData";

export default class CellSelectionType extends BaseSelectionType {
    accept(visitor, selectedRegion) {
        return visitor.visitCellSelection(selectedRegion);
    }

    getSelectedData(lockTable, selectedRegion) {
        var userIds = [];
        var userRows = lockTable.getUserRows(selectedRegion.rowMin, selectedRegion.rowMax);
        for (var i = 0; i < userRows.length; i++) {
            userIds.push(userRows[i].getHeaderCell().getValue().id);
        }

        return new SelectedData(this.getSelectionDateRange(lockTable.getDatesRow(), selectedRegion), userIds);
    }

    checkSelectedUserCells(lockTable, selectedRegion, cellChecker) {
        var userRows = lockTable.getUserRows(selectedRegion.rowMin, selectedRegion.rowMax);
        for (var i = 0; i < userRows.length; i++) {
            var row = userRows[i];
            for (var colIdx = selectedRegion.colMin; colIdx <= selectedRegion.colMax; colIdx++) {
                if (cellChecker(row.getCell(colIdx)))
                    return true;
            }
        }
        return false;
    }

    canBeLocked(lockTable, selectedRegion) {
        return this.checkSelectedUserCells(lockTable, selectedRegion, function(cell) { return !cell.getValue().locked; });
    }

    canBeUnlocked(lockTable, selectedRegion) {
        return this.checkSelectedUserCells(lockTable, selectedRegion, function(cell) { return cell.getValue().locked; });
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/CellSelectionType.js